export default __webpack_public_path__ + "chat_bubble_blue.9f70ce65.svg";